import React, { useState } from "react";
import {
  SwipeableDrawer,
  Box,
  Typography,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import mealImg from "../../Assets/Services/Flight/mealblurred.jpg";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MealDrawer = ({
  open,
  onClose,
  onOpen,
  mealData,
  mealDynamicData,
  selectedMeals,
  updateSelectedMeals,
  passengerCount,
  travelerDetails,
  onDone
}) => {
  console.log("passengerCount", passengerCount);
  console.log("travelerDetails", travelerDetails);
  const [selectedMealsByTraveler, setSelectedMealsByTraveler] = useState({});

  const handleToggleMeal = (travelerIndex, meal) => {
    setSelectedMealsByTraveler((prev) => {
      const travelerMeals = prev[travelerIndex] || [];

      const isAlreadySelected = travelerMeals.some(
        (selectedMeal) =>
          selectedMeal.AirlineCode === meal.AirlineCode &&
          selectedMeal.FlightNumber === meal.FlightNumber &&
          selectedMeal.Code === meal.Code
      );

      const updatedMeals = isAlreadySelected
        ? travelerMeals.filter(
          (selectedMeal) =>
            !(
              selectedMeal.AirlineCode === meal.AirlineCode &&
              selectedMeal.FlightNumber === meal.FlightNumber &&
              selectedMeal.Code === meal.Code
            )
        )
        : [...travelerMeals, meal];

      return {
        ...prev,
        [travelerIndex]: updatedMeals,
      };
    });
  };

  const calculateTotalPrice = () => {
    return Object.values(selectedMealsByTraveler).reduce((total, travelerMeals) => {
      return total + travelerMeals.reduce((sum, meal) => sum + meal.Price, 0);
    }, 0);
  };
  const totalPrice = calculateTotalPrice();
  console.log("Total Price:", totalPrice);

  const handleDone = () => {
    // Iterate over the values of selectedMealsByTraveler, which are arrays of meals
    const travelerMeals = Object.keys(selectedMealsByTraveler).map((travelerIndex) => {
      const meals = selectedMealsByTraveler[travelerIndex];
      const travelerDetail = travelerDetails[travelerIndex]; // Get the traveler detail for the specific index

      return meals.map((meal) => ({
        ...meal, // Spread the meal details
        traveler: travelerDetail // Add traveler details to each meal
      }));
    }).flat(); // Flatten the array to get a single array of meal-traveler combinations

    console.log("Traveler and Meal Details:", travelerMeals);
    if (onDone) {
      onDone(travelerMeals); // ⬅️ Pass the final data to parent here
    }
    onClose(); // optionally close drawer

  };

  console.log("Selected Meals by Traveler:", selectedMealsByTraveler);


  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: 1300 }}
    >
      <Box sx={{ width: '100%', p: 3, mb: "150px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" fontFamily="open sans">
            Select Meal
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box mt={3}>
          {travelerDetails && travelerDetails.length > 0 ? (
            travelerDetails.map((traveler, index) => (
              <Accordion key={index} sx={{ mb: 2 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">
                    {traveler.title} {traveler.firstName} {traveler.lastName}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2}>
                    {mealDynamicData?.[0]?.filter((meal) => meal.Code !== "NoMeal")?.map((meal, mealIndex) => {
                      const isSelected = selectedMealsByTraveler[index]?.some(
                        (m) =>
                          m.AirlineCode === meal.AirlineCode &&
                          m.FlightNumber === meal.FlightNumber &&
                          m.Code === meal.Code
                      );

                      return (
                        <Grid item xs={12} sm={6} md={4} key={mealIndex}>
                          <Card>
                            <CardMedia
                              component="img"
                              height="140"
                              image={mealImg}
                              alt="Meal Image"
                            />
                            <CardContent>
                              <Typography variant="h6" fontWeight="bold">
                                {meal.AirlineDescription || "No Description Available"}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Price: <strong>{meal.Currency} {meal.Price}</strong>
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Route: <strong>{meal.Origin} ➡ {meal.Destination}</strong>
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                Flight: <strong>{meal.AirlineCode} - {meal.FlightNumber}</strong>
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={() => handleToggleMeal(index, meal)}
                              >
                                {isSelected ? "Remove" : "Add"}
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <Typography variant="body1">No traveler details available.</Typography>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          background: "#e3e3e3",
          width: "100%",
          height: "10%",
          position: "fixed",
          bottom: 0,
          padding: "16px",
          display: "flex",
          justifyContent: "flex-start",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" color="primary" >
          Total Price: ₹{totalPrice}
        </Typography>

        <Button variant="contained" color="primary" onClick={handleDone}>
          Done
        </Button>
      </Box>
    </SwipeableDrawer>
  );
};

export default MealDrawer;
